import { useTranslation } from '@dagens/frontend-i18n';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PageHeader } from '@dagens/carrot';
import Logger from '../../../services/Logger';
import { baseUrl } from 'config';
import { Page } from '@components/page';

const GeneratingParcelLabelsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [query, setQuery] = useState('');

  const getParcelExportPdf = async (exportQuery: string) => {
    Logger.info(
      `Exporting parcel labels for iPhone with query: ${exportQuery}`
    );
    window.location.href = `${baseUrl}/export/parcelLabel${exportQuery}`;
  };

  useEffect(() => {
    const urlQuery = location.search;
    if (urlQuery) {
      setQuery(urlQuery);
    }
  }, [location]);

  useEffect(() => {
    if (query) {
      getParcelExportPdf(query);
    }
  }, [query]);

  return (
    <Page hideNav header={null} bottom={null}>
      <PageHeader
        title={t('producer:parcelLabelsGenerating')}
        subtitle={t('producer:parcelLabelsDownloadStartingSoon')}
      />
    </Page>
  );
};

export default GeneratingParcelLabelsPage;
